<template>
  <div class="question-box">
    <div class="question-title">
      <span>{{index+1}}. </span>
      <span class="single-content" v-html="questionContent.content"></span>
      <span class="single-score">({{score}}分)</span>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>

    <div class="question-answer">
      <span>正确答案：</span>
      <div v-html="questionAnswer.content"></div>
    </div>
    <div class="question-answer notop">
      <span>{{name}}的答案：</span>
      <span v-if="!explainAnswer" style="color:red;">未填写答案</span>
      <div v-html="explainAnswer"></div>
      <span class="it-li">+{{student_score}}分</span>
    </div>
    <div class="question-analysis" v-if="analysisContent.content">
      <span>答案解析:</span>
      <div v-html="analysisContent.content"></div>
      <viewer :images="analysisContent.file">
        <img v-for="(src,index) in analysisContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
    <div class="teacher-grade">
      <el-form :model="teacher_read" :rules="readRules" ref="readForm" @submit.native.prevent>
        <el-form-item label="教师评分:" prop="score" v-if="type==='contest'">
          <el-input :placeholder="`请评0-`+score+`分`" v-model.trim="teacher_read.score" @blur="postRead" @keyup.enter.native="$event.target.blur"
            :disabled="itemContent.is_view?true:false"></el-input> &nbsp;分
        </el-form-item>
        <el-form-item label="评价星级:" prop="rate" v-else-if="type==='training'">
          <el-rate v-model="teacher_read.rate" @change="postRead" :disabled="itemContent.is_view?true:false"></el-rate>
          <span style="color:#aaaeb3;">(三星为通过)</span>
        </el-form-item>
        <el-form-item label="教师评语:">
          <el-input type="textarea" :rows="5" placeholder="请输填写评语" v-model="teacher_read.comments" @blur="postRead" @keyup.enter.native="$event.target.blur"
            :disabled="itemContent.is_view?true:false" resize="none"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemContent', 'index', 'name', 'type'],
  data() {
    const validatePassLine = (rule, value, callback) => {
      let max = this.score
      var errors = [];
      if (value > max || value < 0 || value === '') {
        callback(`请输入0-` + max + `以内数值(` + max + `为满分)！`);
      }
      if (!/^[\d\.]*$/.test(value)) {
        callback(`请输入0-` + max + `以内数值(` + max + `为满分)！`);
      }
      if (!/^\d+(\.5?0{0,}|\.0)?$/.test(value)) {
        callback(`小数为0.5倍数！`);
      }
      callback(errors);
    }
    return {
      explainAnswer: '',//答案
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存
      questionAnswer: {},//参考答案
      titleId: '',
      score: '',
      student_score: '',
      is_right: '',
      teacher_read: {
        score: '',
        comments: '',
        rate: 0,
      },
      readRules: {
        score: [
          { required: true, validator: validatePassLine, trigger: ['blur', 'change'] }
        ],
        rate: [
          { required: true, message: '请评价星级', trigger: 'blur' },
        ]
      }
    }
  },
  mounted() {
    this.teacher_read = {
      score: '',
      comments: '',
      rate: 0
    }
    this.initData()
  },
  methods: {
    initData: function () {
      this.explainAnswer = this.itemContent.student_answer
      this.titleId = this.itemContent.id
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
      this.questionAnswer = this.itemContent.parsing.answer
      this.is_right = this.itemContent.right_and_wrong
      this.score = this.itemContent.score
      this.student_score = this.itemContent.single_topic_score
      if (this.itemContent.is_view) {
        this.teacher_read.score = this.itemContent.single_topic_score
        this.teacher_read.comments = this.itemContent.comments
        if (this.type === 'training') {
          this.teacher_read.rate = this.itemContent.single_topic_score
        }
      }
    },
    //教师批阅提交
    postRead: function () {
      if (this.itemContent.is_view) {
        return true
      }
      let subject = {}
      if (this.type === 'contest') {
        subject.score = this.teacher_read.score
      } else if (this.type === 'training') {
        subject.score = this.teacher_read.rate
      }
      subject.comments = this.teacher_read.comments
      subject.title_id = this.titleId,
        subject.title_type = 7,
        subject.answer = this.explainAnswer
      this.$refs['readForm'].validate((valid) => {
        if (valid) {
          this.$root.$emit('returnRemark', subject)
        } else {
          subject.score = ''
          this.$root.$emit('returnRemark', subject)
        }
      })

    },
  },
}
</script>

<style scoped>
.el-form .el-form-item .el-rate {
  height: 20px;
  line-height: 50px;
}
</style>